import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState, useCallback } from 'react';
import { getSubscriptionsApi } from '../../api/subscriptionManagement.api';
import TableView from '../../../Basic/TableView';
import { columnConfig } from './columnConfig';
export var SubscriptionTable = function SubscriptionTable(_ref) {
  var isOpen = _ref.isOpen,
      solutionId = _ref.solutionId,
      handleEdit = _ref.handleEdit,
      forceRefresh = _ref.forceRefresh,
      translate = _ref.translate;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isFirstOpen = _useState4[0],
      setFirstOpenCount = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      tableData = _useState6[0],
      setTableData = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      total = _useState8[0],
      setTotal = _useState8[1];

  var _useState9 = useState(1),
      _useState10 = _slicedToArray(_useState9, 2),
      pageIndex = _useState10[0],
      setPageIndex = _useState10[1];

  var _useState11 = useState(10),
      _useState12 = _slicedToArray(_useState11, 2),
      pageSize = _useState12[0],
      setPageSize = _useState12[1];

  var _useState13 = useState('asc'),
      _useState14 = _slicedToArray(_useState13, 2),
      orderDirection = _useState14[0],
      setOrderDirection = _useState14[1];

  var _useState15 = useState('expiryDate'),
      _useState16 = _slicedToArray(_useState15, 2),
      orderBy = _useState16[0],
      setOrderBy = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      tableChanged = _useState18[0],
      setTableChanged = _useState18[1];

  var tableChange = function tableChange(_ref2) {
    var orderId = _ref2.orderId,
        orderDirection = _ref2.orderDirection,
        pageIndex = _ref2.pageIndex,
        pageSize = _ref2.pageSize;
    setPageIndex(pageIndex + 1);
    setPageSize(pageSize);
    setOrderDirection(orderDirection);
    setOrderBy(orderId);
    setTableChanged(true);
  };

  var getSubscriptions = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$getSubscriptio, data, _tableData;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return getSubscriptionsApi({
              solutionId: solutionId,
              pageSize: pageSize,
              pageIndex: pageIndex,
              orderBy: orderBy,
              orderDirection: orderDirection
            });

          case 4:
            _yield$getSubscriptio = _context.sent;
            data = _yield$getSubscriptio.data;
            _tableData = data.rows && data.rows.map(function (i) {
              return i.licensedUser ? _objectSpread(_objectSpread({}, i), {}, {
                licensedUser: _objectSpread(_objectSpread({}, i.licensedUser), {}, {
                  FirstName: i.licensedUser.givenName,
                  LastName: i.licensedUser.surname,
                  Email: i.licensedUser.email
                })
              }) : i;
            });
            setTableData(_tableData || []);
            setTotal(data.total);
            setLoading(false);
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            setLoading(false);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  })), [orderBy, orderDirection, pageIndex, pageSize, solutionId]);
  useEffect(function () {
    // when the Panel opened first, call the api to get data
    if (isOpen && (isFirstOpen || tableChanged)) {
      setFirstOpenCount(false);
      setTableChanged(false);
      getSubscriptions();
    }
  }, [isOpen, isFirstOpen, tableChanged, getSubscriptions]);
  useEffect(function () {
    if (forceRefresh > 0) {
      getSubscriptions();
    }
  }, [forceRefresh, getSubscriptions]);
  return /*#__PURE__*/React.createElement(TableView, {
    loading: loading,
    data: tableData,
    total: total,
    columns: columnConfig(handleEdit, translate),
    onChange: tableChange,
    onSortedChange: tableChange
  });
};